/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Type_TitleInputs */

const vi_tea_type_title = /** @type {(inputs: Tea_Type_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loại chè`)
};

/**

* @param {Tea_Type_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_type_title = /** @type {((inputs?: Tea_Type_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Type_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_type_title(inputs)
});